import type { OpenAction } from './types';

export const openActions: Record<string, OpenAction> = {
    intercom: ({ intercom, params }) => {
        intercom.showNewMessage(params.get('message') ?? undefined);
    },
};
